import styled from 'styled-components';
import { spacings } from '../../tokens/spacings';
import { theme } from '../../tokens/theme';

export const MetadataWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(15, 1fr);
  grid-template-rows: repeat(7, auto);
  gap: 1.5rem;
  padding: ${spacings.X_LARGE};
  max-width: 1280px;
  min-height: 100%;
  background-color: ${theme.light.ui.background.default};
  box-sizing: border-box;

  > * {
    grid-column: 1 / -1; // Each card will display in full width by default
    min-width: 0;
    border: 1px solid ${theme.light.ui.background.medium};
    border-radius: 4px;

    && {
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
    }
  }

  .model-title,
  .card-title {
    font-weight: 700;
  }

  .model-title {
    word-break: break-all;
  }

  /* 
    Assign explicit grid rules for the cards that are split into multiple columns and rows
    The grid-area shorthand is "row-start / column-start / row-end / column-end"
   */
  .card-name {
    grid-area: auto / 1 / auto / 7;
  }

  .card-areas {
    grid-area: auto / 1 / auto / 7;
  }

  .card-image {
    grid-area: 1 / 7 / span 2 / 16;
    min-width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    :has(.model-error-message) & {
      grid-area: 2 / 7 / span 2 / 16;
    }
  }

  .card-files {
    grid-area: auto / 1 / auto / 11;
  }

  .card-ini {
    grid-area: auto / 11 / auto / 16;
  }

  .card-actions-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    border: none;
    border-radius: 0;
    box-shadow: none;
    padding: 0;

    > * {
      border: 1px solid ${theme.light.ui.background.medium};
      border-radius: 4px;
    }
  }
`;
